import styled from 'styled-components';
export const Container = styled.div`
   display: flex;
   width: 100%;
   min-height: 4rem;
   flex-direction: row;
   justify-content: space-between;
   align-items: center;
   margin-bottom: 0.75rem;
   .line{
      display: flex;
      flex: 2;
      height: 2px;
      justify-content: center;
      align-items: center;
      background-color: #0000001a;
   }
   .msg--{
      display: flex;
      flex: 5;
      justify-content: center;
      align-items: center;
      text-align: center;
      padding: 0 0.5rem;
      background-color: transparent;
      color: #999999;
   }
`